<button [attr.id]="id" mat-icon-button aria-label="Subir un archivo" (click)="openModal()">
  <mat-icon [matBadge]="null" matBadgeColor="warn">cloud_upload</mat-icon>
</button>
